module.exports = __webpack_public_path__ + "static/about-developer1-d7bccff9a4b7e4f8bcedd969640384d7.jpg";